<template>
  <div id="app" :class="getClass">
    <router-view />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { isDesktop } from '@/utils/util'
import { deviceEnquire } from '@/utils/device'
import { APP_MUTATIONS } from '@/store/storage-types'

export default {
  name: 'App',
  computed: {
    getClass() {
      return isDesktop() ? 'client-app' : 'phone-app'
    }
  },
  mounted() {
    deviceEnquire(deviceType => {
      // 切换设备类型
      this[APP_MUTATIONS.TOGGLE_DEVICE](deviceType)
    })
  },
  methods: {
    ...mapMutations([APP_MUTATIONS.TOGGLE_DEVICE, APP_MUTATIONS.TOGGLE_SIDE_BAR_COLLAPSED])
  }
}
</script>

<style lang="scss" scoped>
@import url('@/styles/app.scss');
</style>
